import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lecenje-zuba',
  templateUrl: './lecenje-zuba.component.html',
  styleUrls: ['./lecenje-zuba.component.css']
})
export class LecenjeZubaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
